import React, { useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { ContentTitle } from '../ui/styled';
import BackIcon from '../common/Back/BackIcon';
import PageHeading from '../common/Heading/PageHeading';
import CommonSearch from '../common/Search/CommonSearch';

const ComplianceList = (props) => {
  const [searchComplianceList, setSearchComplianceList] = useState('');
  const [complianceList, setComplianceList] = useState({
    isLoading: false,
    data: [
      {
        id: '1',
        orgId: '76',
        organizationKey: '65',
        country: 'UK',
        complianceType: '-',
        complianceNumber: '89867',
        startDate: '8/09/1998',
        endDate: '6/12/2010',
        orgInActive: '-',
      },
    ],
    total: 0,
    page: 1,
    pageSize: 10,
    sortModel: '',
  });

  //   const handleSortModelChange = useCallback((sortModel) => {
  //     // Here you save the data you need from the sort model
  //     setEpisodeData((old) => ({ ...old, sortModel: [...sortModel] }));
  //   }, []);

  const QuickSearchToolbar = () => {
    return (
      <CommonSearch searchText={searchComplianceList} setSearchText={setSearchComplianceList} />
    );
  };

  const columnsData = [
    { field: 'orgId', headerName: 'Org Id', flex: 1 },
    {
      field: 'organizationKey',
      headerName: 'Organization Key',
      flex: 1,
    },
    {
      field: 'country',
      headerName: 'Country',
      flex: 1,
    },
    {
      field: 'complianceType',
      headerName: 'Compliance Type',
      flex: 1,
    },
    {
      field: 'complianceNumber',
      headerName: 'Compliance Number',
      flex: 1,
    },
    {
      field: 'startDate',
      headerName: 'Start Date',
      type: 'date',
      flex: 1,
    },
    { field: 'endDate', headerName: 'End Date', type: 'date', flex: 1 },
    { field: 'orgInActive', headerName: 'Org InActive', flex: 1 },
  ];

  return (
    <>
      <ContentTitle container>
        <BackIcon />
        <PageHeading title='Compliance List' />
      </ContentTitle>
      <DataGrid
        autoHeight
        getRowHeight={() => 'auto'}
        columns={columnsData}
        rows={complianceList.data}
        pageSize={complianceList.pageSize}
        page={complianceList.page - 1}
        rowCount={complianceList.total}
        paginationMode='server'
        sortingMode='server'
        onPageSizeChange={(newPageSize) =>
          setComplianceList((old) => ({ ...old, pageSize: newPageSize }))
        }
        onPageChange={(newPage) => {
          setComplianceList((old) => ({ ...old, page: newPage + 1 }));
        }}
        rowsPerPageOptions={[10, 25, 50]}
        pagination
        components={{ Toolbar: QuickSearchToolbar }}
        experimentalFeatures={{ newEditingApi: true }}
        getRowClassName={(params) =>
          params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
        }
      />
    </>
  );
};
export default ComplianceList;
